import { useState } from "react";
import {
  Select,
  MenuItem,
  TextField,
  Button,
  Grid,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";

const CylinderBooking = () => {
  const [provider, setProvider] = useState("");
  const [customerMobNo, setCustomerMobNo] = useState("");
  const [consumerNo, setConsumerNo] = useState("");
  const [distributorCode, setDistributorCode] = useState("");
  const [consumerId, setConsumerId] = useState("");
  const [fetchingAmount, setFetchingAmount] = useState(false);
  const [amount, setAmount] = useState(null);

  const handleFetchAmount = () => {
    setFetchingAmount(true);
    setTimeout(() => {
      setAmount("₹850");
      setFetchingAmount(false);
    }, 2000);
  };

  return (
    <Box
      sx={{
        p: 4,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#e0f0f1",
        border: "2px solid rgb(252, 216, 162)",
      }}
    >
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={12} md={12} lg={6}>
          <Box
            sx={{
              p: 4,
              borderRadius: 4,
              bgcolor: "white",
              textAlign: "center",
          
            }}
          >
            <Typography variant="h5" gutterBottom fontWeight={600} color="#00796b">
              Cylinder Booking
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom fontWeight={500} color="#00796b">
                  Select Provider
                </Typography>
                <Select
                  fullWidth
                  value={provider}
                  onChange={(e) => setProvider(e.target.value)}
                  displayEmpty
                  variant="outlined"
                >
                  <MenuItem value="" disabled>
                    Select your provider
                  </MenuItem>
                  <MenuItem value="Indane">Indane Gas (Indian Oil)</MenuItem>
                  <MenuItem value="HP">HP Gas (HPCL)</MenuItem>
                  <MenuItem value="Bharat">Bharat Gas (BPCL)</MenuItem>
                </Select>
              </Grid>

              {provider && (
                <>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Customer Mobile No*"
                      variant="outlined"
                      value={customerMobNo}
                      onChange={(e) => setCustomerMobNo(e.target.value)}
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Consumer No*"
                      variant="outlined"
                      value={consumerNo}
                      onChange={(e) => setConsumerNo(e.target.value)}
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Distributor Code*"
                      variant="outlined"
                      value={distributorCode}
                      onChange={(e) => setDistributorCode(e.target.value)}
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Consumer ID*"
                      variant="outlined"
                      value={consumerId}
                      onChange={(e) => setConsumerId(e.target.value)}
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleFetchAmount}
                      disabled={!customerMobNo || !consumerNo || !distributorCode || !consumerId}
                      sx={{ mt: 2, width: "100%", py: 1.5, fontSize: "1rem", fontWeight: 600 }}
                    >
                      {fetchingAmount ? <CircularProgress size={24} color="inherit" /> : "Fetch Amount"}
                    </Button>
                  </Grid>

                  {amount && (
                    <Grid item xs={12}>
                      <Box mt={2} p={2} borderRadius={2} bgcolor="primary.light" display="inline-block">
                        <Typography variant="h6" fontWeight={700}>
                          Amount: {amount}
                        </Typography>
                      </Box>
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      sx={{
                        mt: 2,
                        width: "100%",
                        py: 1.5,
                        fontSize: "1rem",
                        fontWeight: 600,
                        bgcolor: "#00796b",
                        "&:hover": { bgcolor: "#004d40" },
                      }}
                      disabled={!amount}
                    >
                      Pay Now
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CylinderBooking;
